module.exports = __webpack_public_path__ + "img/emoticon-nps-7-on.8a51b83e.svg";